export const ja = {
  common: {
    cancel: 'キャンセル',
    confirm: '確認',
    save: '保存',
    delete: '削除',
    edit: '編集',
    close: '閉じる',
    loading: '読み込み中...',
    success: '成功',
    error: 'エラー',
    retry: '再試行',
    optional: '任意',
  },
  app: {
    Home: 'ホーム',
    Create: '作成',
    Projects: 'プロジェクト',
    Templates: 'テンプレート',
    LivePreview: 'ライブプレビュー',
    Resource: 'リソース',
    Assets: 'アセット',
    Tool: 'ツール',
    AllTools: '全てのツール',
    Settings: '設定',
    logout: 'ログアウト',
    Feedback: 'フィードバック',
    Support: 'サポート',
    profile: 'プロフィール',
    generationHistory: '生成履歴',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    invite: '友達を招待',
    RedemptionCode: '引き換えコード',
    APIKeys: 'APIキー',
    getMoreCredits: 'クレジットを追加',
    earnCredits: 'クレジットを獲得',
    inviteFriends: '友達を招待',
    referralProgram: '紹介プログラム',
    creditsEarned: '獲得クレジット',
    shareToEarn: '共有してクレジット獲得',
    dailyRewards: 'デイリーリワード',
    completeProfile: 'プロフィール完成',
    creditsRemaining: 'クレジット残高：',
    upgrade: 'アップグレード',
    Workspace: 'ワークスペース',
    claimed: '受取済み',
    claimFreeCredits: '無料クレジットを受け取る',
    accountSettings: 'アカウント設定',
  },
  dailyCredits: {
    success: {
      title: '成功',
      description: 'デイリークレジットを受け取りました！',
    },
    error: {
      title: 'エラー',
      description: 'クレジットの受け取りに失敗しました',
    },
  },
  design: {
    group: 'グループ',
    Ungroup: 'グループ解除',
    background: '背景',
    replace: '置換',
    replaceImage: '画像を置換',
    generateImage: 'AIで画像生成',
    generate: 'AI生成',
    rembg: '背景削除',
    processing: '処理中...',
    recents: '最近使用',
    assets: 'アセット',
    qrcode: 'QRコード',
    uploadImage: '画像をアップロード',
    opacity: '透明度',
    radius: '半径',
    rotation: '回転',
    border: 'ボーダー',
    position: '位置とサイズ',
    shadow: 'シャドウ',
    shadowPanel: {
      color: '色',
      parameters: 'パラメータ',
      presets: 'プリセット',
      none: 'なし',
      blur: 'ぼかし',
      spread: '拡散',
    },
    flipPanel: {
      flip: '反転',
      horizontal: '水平',
      vertical: '垂直',
      flipHorizontal: '水平反転',
      flipVertical: '垂直反転',
    },
    backdropFilter: 'バックドロップフィルター',
    backdropPanel: {
      none: 'なし',
      'grayscale(100%)': 'グレースケール',
      'sepia(100%)': 'セピア',
      'blur(5px)': 'ぼかし',
      'brightness(150%)': '明度',
      'contrast(150%)': 'コントラスト',
      'invert(100%)': '反転',
      'saturate(200%)': '彩度',
    },
    Custom: 'カスタム',
    Presets: 'プリセット',
    letterSpacing: '文字間隔',
    lineHeight: '行の高さ',
    padding: {
      padding: 'パディング',
      top: '上',
      bottom: '下',
      left: '左',
      right: '右',
    },
    save: '保存',
    textSettings: 'テキスト設定',
    groupSettings: 'グループ設定',
    children: '子要素',
    mixedNode: '混合ノード',
    variableLabel: '変数ラベル',
    textStyle: 'テキストスタイル',
    fontFamily: 'フォントファミリー',
    textAlignment: 'テキスト配置',
    highlight: 'ハイライト',
    stroke: 'ストローク',
    effect: 'エフェクト',
    filter: 'フィルター',
    color: '色',
    size: 'サイズ',
    decoration: '装飾',
    spacing: '間隔',
    effects: 'エフェクト',
    clearEffects: 'エフェクトをクリア',
    highlightTip: 'まずテキストを選択してから、ハイライトスタイルを適用してください',
    advancedSettings: '詳細設定',
    strokeWidth: 'ストローク幅',
    verticalAlign: '垂直配置',
    horizontalAlign: '水平配置',
    alignTop: '上揃え',
    alignMiddle: '中央揃え',
    alignBottom: '下揃え',
    alignLeft: '左揃え',
    alignCenter: '中央揃え',
    alignRight: '右揃え',
    font: {
      allFonts: '全てのフォント',
      Chinese: '中国語フォント',
      English: '英語フォント',
      Local: 'ローカルフォント',
      fontStyles: 'フォントスタイル',
      language: '言語',
      searchFonts: 'フォント検索...',
      addLocalFont: 'フォントを追加',
      removeLocalFont: 'フォントを削除',
      noLocalFonts: 'ローカルフォントはありません',
      uploading: 'アップロード中...',
      noFontsFound: 'フォントが見つかりません',
    },
    pageSettings: 'ページ設定',
    solid: '単色',
    gradient: 'グラデーション',
    image: '画像',
    presets: 'プリセット',
    noise: 'ノイズ',
    blur: 'ぼかし',
    overlay: 'オーバーレイ',
    clipPath: 'クリップパス',
    imageSettings: '画像設定',
    objectFit: 'オブジェクトフィット',
    bgRemover: '背景削除',
    crop: 'クロップ',
    imageStyle: '画像スタイル',
    imageFilter: '画像フィルター',
    imageSource: '画像ソース',
    backgroundRemoval: '背景削除',
    imageUpscale: '画像拡大',
    enhanceImageQuality: '画像品質と解像度を向上',
    imageEditing: '画像編集',
    cropDescription: '画像のサイズ変更と再フレーミング',
    removeObjects: 'オブジェクト削除',
    imageInpaint: '不要なオブジェクトをペイント',
    borderColor: 'ボーダー色',
    borderWidth: 'ボーダー幅',
    rotate: '回転',
    textEffect: 'テキストエフェクト',
    textHighlight: 'テキストハイライト',
    applyHighlight: 'ハイライト適用',
    highlightColor: 'ハイライト色',
    highlightStyle: 'ハイライトスタイル',
    highlightOpacity: 'ハイライト透明度',
    textDecoration: 'テキスト装飾',
    underline: '下線',
    strikethrough: '取り消し線',
    italic: '斜体',
    bold: '太字',
    shape: 'シェイプ',
    moreOptions: 'その他のオプション',
    patternColor: 'パターン色',
    patternSize: 'パターンサイズ',
    applyPattern: 'パターン適用',
    glassLight: 'ガラスライト',
    default: 'デフォルト',
    filterIntensity: 'フィルター強度',
    glassBlack: 'ガラスブラック',
    outline: 'アウトライン',
    shadowOptions: 'シャドウオプション',
    shadowNone: 'なし',
    shadowSmall: '小',
    shadowMedium: '中',
    shadowLarge: '大',
    shadowXLarge: '特大',
    shadowInner: '内側',
    shadowSoft: 'ソフト',
    shadowHard: 'ハード',
    shadowOffset: 'オフセット',
    shadowSpread: '拡散',
    customShadow: 'カスタムシャドウ',
    // Image filters
    filters: {
      Binarize: '2値化',
      Brightness: '明るさ',
      Gamma: 'ガンマ',
      Sharpen: 'シャープ',
      Solarize: 'ソラリゼーション',
      GrayScale: 'グレースケール',
      GaussianBlur: 'ガウスぼかし',
    },
    removeBackground: '背景を削除',
    tools: {
      undo: '元に戻す',
      redo: 'やり直し',
      selectionMode: '選択モード',
      handTool: 'ハンドツール',
      defaultSelectionMode: 'デフォルト選択モード',
      deepSelectionMode: 'ディープ選択モード',
      zoomToFit: 'フィットズーム',
      zoomIn: 'ズームイン',
      zoomOut: 'ズームアウト',
      addText: 'テキスト追加',
      addImage: '画像追加',
      addRectangle: '四角形追加',
      addCircle: '円追加',
      addIcon: 'アイコン追加',
      addQRCode: 'QRコード追加',
      text: 'テキスト',
      image: '画像',
      shape: 'シェイプ',
      rectangle: '四角形',
      circle: '円',
      icon: 'アイコン',
      qrCode: 'QRコード',
      dragAndDrop: 'キャンバスにドラッグ&ドロップ',
      clickToAdd: 'クリックして追加',
    },

    // Shadow options
    shadowCustom: 'カスタム',
    shadowColor: 'シャドウ色',
    shadowBlur: 'シャドウぼかし',
    shadowDistance: 'シャドウ距離',
    shadowAngle: 'シャドウ角度',

    // Image styles
    imageStyleDefault: 'デフォルト',
    imageStyleGlassLight: 'ガラスライト',
    imageStyleGlassBlack: 'ガラスブラック',
    imageStyleOutline: 'アウトライン',

    // Filter effects
    filterNone: 'なし',
    filterVintage: 'ヴィンテージ',
    filterSepia: 'セピア',
    filterDramatic: 'ドラマチック',
    filterSharp: 'シャープ',
    filterCool: 'クール',
    filterWarm: 'ウォーム',
    publish: {
      title: 'デザインを共有',
      publishDescription: 'コミュニティとデザインを共有',
      selectPage: 'ページ選択',
      choosePage: 'エクスポートするページを選択',
      name: '名前',
      description: '説明',
      tags: 'タグ',
      tagPlaceholder: 'タグ...',
      publish: '公開',
      update: '更新',
      uploading: 'アップロード中',
      success: {
        title: 'テンプレート共有成功',
        description: 'テンプレートがコミュニティギャラリーで利用可能になりました',
      },
      error: {
        title: 'テンプレート共有失敗',
        description: '問題が発生しました。接続を確認して再試行してください。',
      },
      projectPermissions: 'アクセスレベル',
      publishTemplate: 'テンプレート公開',
      visibility: 'プロジェクト可視性',
      public: '公開',
      publicDescription: '誰でもコミュニティギャラリーでこのプロジェクトを閲覧できます',
      private: '非公開',
      privateDescription: 'あなたと共有した人のみこのプロジェクトにアクセスできます',
      updating: '更新中...',
      updatePermissions: '権限を更新',
      shareLink: '共有リンク',
      copyLink: 'リンクをコピー',
      linkCopied: 'リンクがクリップボードにコピーされました！',
      embedCode: '埋め込みコード',
      copyCode: 'コードをコピー',
      codeCopied: 'コードがクリップボードにコピーされました！',
      shareUrl: '共有URL',
      shareUrlPublicDesc: 'このリンクを持つ誰でもプロジェクトを閲覧できます',
      shareUrlPrivateDesc: 'このリンクであなたのみプロジェクトにアクセスできます',
      publicAccess: '公開アクセス',
      privateAccess: '非公開アクセス',
      urlWillAppearHere: 'URLがここに表示されます',
      urlReady: 'URLの準備完了',
      urlNotReady: 'URL未対応',
      copy: 'コピー',
      copySuccess: 'コピー完了！',
      copySuccessDesc: '共有URLがクリップボードにコピーされました',
      copyFailed: 'コピー失敗',
      copyFailedDesc: 'URLのクリップボードコピーに失敗しました',
    },
  },
  imageMenu: {
    title: 'AI画像エディター',
    description: 'AIで画像を編集',
    modelOptions: {
      gemini: 'Gemini',
      openai: 'GPT-4o',
      comingSoon: '近日公開',
    },
    placeholder: '希望する画像の変更を説明してください...',
    generate: '画像編集',
    loading: '生成中...',
    editImage: 'AI画像編集',
    selectModel: 'モデル選択',
  },
  actions: {
    Undo: '元に戻す',
    Redo: 'やり直し',
    Duplicate: '複製',
    Paste: '貼り付け',
    Delete: '削除',
    Layer: 'レイヤー',
    Alignment: '配置',
    SelectLayer: 'レイヤー選択',
    CopyAs: 'コピー',
    CopyasPNG: 'PNGとしてコピー',
    CopyasWebp: 'Webpとしてコピー',
    CopyasHTML: 'HTMLとしてコピー',
    CopyAsRawHTML: 'インラインHTMLとしてコピー',
    Forward: '前面へ',
    Backward: '背面へ',
    BringToFront: '最前面へ',
    SendToBack: '最背面へ',
    alignToPageTop: 'ページ上部に配置',
    alignToPageLeft: 'ページ左側に配置',
    alignToPageMiddle: 'ページ中央に配置',
    alignToPageCenter: 'ページ中心に配置',
    alignToPageBottom: 'ページ下部に配置',
    alignToPageRight: 'ページ右側に配置',
    alignToTop: '上揃え',
    alignToBottom: '下揃え',
    alignToMiddle: '中央揃え',
    alignToCenter: '中心揃え',
    alignToLeft: '左揃え',
    alignToRight: '右揃え',
    AddToLibrary: 'ライブラリに追加',
    CopyTextStyle: 'スタイルをコピー',
    PasteTextStyle: 'スタイルを貼り付け',
    Advanced: '高度な設定',
    selectAll: '全て選択',
    MergeFrames: 'フレームを結合',
    flipHorizontal: '水平反転',
    flipVertical: '垂直反転',
  },
  landing: {
    seoTitle: 'Seede AI - 誰でも使えるシンプル、高速、楽しいAIグラフィックデザイン',
    seoDescription:
      'アイデアを1クリックでデザインに！Seede AIがソーシャル&マーケティング投稿を瞬時に作成。ソフトウェアの学習不要 - 無料でお試し！',
    seoKeywords:
      'seede, seede ai, AIポスター, ダウンロード不要の無料デザインツール,LinkedIn投稿,AIポスタージェネレーター, 無料デザインツール,簡単デザイン',
    featuresSubtitle: '強力な機能',
    featuresDescription:
      'グラフィックデザインでAIを活用する方法？Seede aiは、デザインワークフローを効率化し、素晴らしいビジュアルを簡単に作成できるAI搭載ツールスイートを提供します。',
    signIn: 'ログイン',
    signUp: 'サインアップ',
    recommendations: '推奨',
    refresh: '更新',
    productFeatures: '機能',
    useCases: '活用事例',
    pricing: '価格',
    products: '製品',
    templates: 'テンプレート',
    getStarted: '始める',
    tryForFree: '無料で試す',
    heroTitle: `<span style="display: inline-block; margin-left: 1rem;">あなたのアイデア。秒で完成。</span>`,
    heroSubtitle: 'Seede AIでプロのグラフィックデザインをシンプルに',
    creatorCount:
      'Seede AI — 誰もがワンクリックでプロフェッショナルなデザインとレイアウトを作成できます。',
    coreFeaturesBadge: 'コア機能',
    learnMore: '詳細を見る',
    browserAllTemplates: '全てのテンプレートを見る',
    startUsing: '無料で作成開始',
    whatIsSeede: 'Seede AIとは？',
    richTemplates: '豊富なAIクリエイティブテンプレート',
    whyNotTry: 'ぜひ試してみてください',
    whatIsSeedeDesc: `Seede aiは、デザインスキル不要で1分で素晴らしいビジュアルを作成できるAI搭載デザインツールです。ソーシャルメディアコンテンツ、マーケティング素材、クリエイティブプロジェクトに最適です。`,
    mainFeatures: '主要機能',
    createWithAI: 'AIで自由に、瞬時に創作。',
    freeTools: '無料画像処理ツール',
    ctaTitle: '今すぐAI搭載デザインを体験',
    ctaNow: '今すぐ Seede AI を無料でお試しください',
    startCreating: '作成開始',
    footerDesc:
      'Seede ai - クリエイティブワークをシンプル、高速、楽しくするAI搭載デザインツール | Seede AIで瞬時にプロフェッショナルなデザインを作成',
    product: '製品',
    features: '機能',
    cases: '活用事例',
    resources: 'リソース',
    helpCenter: 'ヘルプセンター',
    docs: 'ドキュメント',
    company: '会社',
    team: 'チーム',
    affiliates: 'アフィリエイト',
    aboutUs: '会社概要',
    blog: 'ブログ',
    contactUs: 'お問い合わせ',
    dashboard: 'ダッシュボード',
    tools: 'ツール',
    howItWorks: '使い方',
    howYouCanDesign: 'プロのようにデザインする方法',
    createInFourSteps: '4つのシンプルなステップで素晴らしいデザインを作成',
    steps: {
      step1Title: '説明',
      step1Desc: 'デザインしたいものを説明します。',
      step2Title: '作成',
      step2Desc: 'Seedeが最初のバージョンを作成します。',
      step3Title: '改善',
      step3Desc: '変更を依頼して改善します。',
      step4Title: 'エクスポート',
      step4Desc: 'デザインをエクスポートして公開または印刷します。',
    },
    designSteps: {
      idea: {
        title: 'ただのアイデア',
        desc: '頭の中にあるどんなアイデアからでも始められます。大きくても小さくても構いません。',
      },
      generate: {
        title: '生成',
        desc: '思いついたことを入力して、生成ボタンを押すだけ',
      },
      seconds: {
        title: 'わずか数秒で',
        desc: '数秒待つだけで、魔法が起こります。プロのようなデザインが完成します。',
      },
      export: {
        title: '改善またはエクスポート',
        desc: 'Seede AIとチャットしながらブレインストーミングするか、直接エクスポートして使用できます。',
      },
    },
    socialProof: '{{user}}人のクリエイターがSeedeでデザインしています',
    // 新增翻译
    featureDesc: 'AI搭載プロフェッショナルデザイン生成ツール',
    featuresIntroStrong: 'Seede aiはAIデザインツールです',
    featuresIntroLight:
      '数秒で素晴らしいビジュアルを作成できます。デザインスキルは不要です。ソーシャルメディアコンテンツ、マーケティング資料、クリエイティブプロジェクトに最適です。',
    feature1: '1分で<br/>デザイン完成',
    feature1Desc: 'デザイン経験不要、あらゆる業界のマーケティングデザインを1分で作成',
    feature2: '参考画像から<br/>デザイン生成',
    feature2Desc: '参考画像をアップロード、AIが類似スタイルを作成',
    feature3: '自由編集 + AI支援',
    feature3Desc: 'レイヤー編集で要素を生成、AI支援による部分的最適化',
    tool1: '横向き動画を縦向きに変換ツール',
    tool1Desc: 'ソーシャルメディア用に横向き動画を縦向きフォーマットに変換',
    tool2: '背景除去',
    tool2Desc: 'ワンクリック背景除去',
    tool3: 'マジック消しゴム',
    tool3Desc: '不要な要素を簡単に除去',
    tool4: '画像生成',
    tool4Desc: 'テキストから画像を生成',
    tool5: '画像高画質化',
    tool5Desc: '画像解像度を向上',
  },
  products: {
    posterGenerator: {
      title: 'イベントポスタージェネレーター',
      name: 'イベントポスター',
      description: 'プロフェッショナルなイベントポスターを素早く作成',
    },
    invitationGenerator: {
      title: '招待状ジェネレーター',
      name: '招待状',
      description: '美しいデジタル招待状を作成',
    },
    infographicGenerator: {
      title: 'インフォグラフィックジェネレーター',
      name: 'インフォグラフィック',
      description: '視覚的に魅力的なデータ駆動型インフォグラフィックを作成',
    },
    newsletterGenerator: {
      title: 'ニュースレタージェネレーター',
      name: 'ニュースレター',
      description: 'プロフェッショナルなニュースレターテンプレートを作成',
    },
    flashcardGenerator: {
      title: 'フラッシュカードジェネレーター',
      name: 'フラッシュカード',
      description: '学習用フラッシュカードを生成',
    },
    socialMediaGenerator: {
      title: 'ソーシャルメディア投稿',
      name: 'ソーシャルメディア投稿',
      description: 'AIで魅力的なソーシャルメディアコンテンツを作成',
    },
    wechatCoverGenerator: {
      title: 'WeChatカバージェネレーター',
      name: 'WeChatカバー',
      description: 'AIで目を引くWeChat記事カバーを作成',
    },
    eventPromotionGenerator: {
      title: 'イベントプロモーションジェネレーター',
      name: 'イベントプロモーション',
      description: '目を引くイベントプロモーションと広告をデザイン',
    },
    albumCoverGenerator: {
      title: 'アルバムカバージェネレーター',
      name: 'アルバムカバー',
      description: 'AIで素晴らしい音楽アルバムカバーをデザイン',
    },
    signageGenerator: {
      title: 'サイネージジェネレーター',
      name: 'サイネージ',
      description: 'プロフェッショナルなサイネージと表示材料を作成',
    },
    menuGenerator: {
      title: 'レストランメニュージェネレーター',
      name: 'レストランメニュー',
      description: 'AIを使用して視覚的に素晴らしいレストランやカフェのメニューを作成',
    },
    flyerGenerator: {
      title: 'フライヤージェネレーター',
      name: 'フライヤー',
      description:
        '迷子のペット、ギャラリーの開館、募金イベントなど、美しいフライヤーを簡単なツールで作成',
    },
    scrollytellingGenerator: {
      title: 'スクロールストーリージェネレーター',
      name: 'スクロールストーリー',
      description:
        'データストーリーと記憶に残る瞬間を完璧に表現する視覚的に魅力的な長文コンテンツを作成し、ソーシャルメディアでのシェアをより魅力的に',
    },
    presentationGenerator: {
      title: 'プレゼンテーションジェネレーター',
      name: 'プレゼンテーション',
      description: 'AI搭載デザインでプロフェッショナルなプレゼンテーションスライドを作成',
    },
    diagramGenerator: {
      title: '図表ジェネレーター',
      name: '図表',
      description: 'AI搭載デザインでプロフェッショナルな図表やフローチャートを作成',
    },
    multiPageBrochureGenerator: {
      title: 'パンフレットジェネレーター',
      name: 'パンフレット',
      description: 'AIで複数ページのプロフェッショナルなパンフレットを作成',
    },
    pullUpBanner: {
      title: 'ロールアップバナージェネレーター',
      name: 'ロールアップバナー',
      description: 'AIで目を引くロールアップバナーをデザイン',
    },
  },
  workspace: {
    templatesGroup: 'テンプレート',
    promptLibrary: 'プロンプトライブラリ',
    featuredDesigns: '注目のデザイン',
    ai: 'Seede AI',
    create: '作成',
    createTitle: '今日は何を作成しますか？',
    quickStart: 'クイックスタート',
    morePromptTemplates: 'その他のプロンプトテンプレート',
    allDesigns: 'すべてのデザイン',
    recentlyReviewed: '最近見たもの',
    assets: 'アセット',
    themes: 'テーマ',
    trash: 'ゴミ箱',
    libraries: 'ライブラリ',
    settings: '設定',
    invite: '友達を招待',
    redeem: '引き換えコード',
    newDesign: '新規デザイン',
    searchDesigns: 'デザインを検索...',
    sortBy: '並べ替え',
    all: 'すべて',
    recentlyViewed: '最近閲覧したもの',
    favorites: 'お気に入り',
    recentlyUpdated: '最近更新されたもの',
    oldestUpdated: '古い更新順',
    recentlyCreated: '最近作成されたもの',
    oldestCreated: '古い作成順',
    noDesignsFound: 'デザインが見つかりません',
    createFirstDesign: '最初のデザインを作成して始めましょう',
    loadingProjects: 'プロジェクトを読み込み中...',
    deleteProject: 'プロジェクトを削除',
    confirmDelete: 'このプロジェクトを削除してもよろしいですか？',
    cancel: 'キャンセル',
    delete: '削除',
    loadingMore: 'さらにプロジェクトを読み込み中...',
    noProjectsFound: 'プロジェクトが見つかりません',
    createFirstProject: '最初のプロジェクトを作成して始めましょう',
    newProject: '新規プロジェクト',
    searchProjects: 'プロジェクトを検索...',
    loadingDesigns: 'デザインを読み込み中...',
    createNewDesign: '新規デザインを作成',
    welcomeTitle: 'ワークスペースへようこそ',
    welcomeDescription:
      'AI搭載ツールで素晴らしいデザインの作成を始めましょう。あなたの創造力に限界はありません。',
    createFirstDesignButton: '最初のデザインを作成',
    recentWork: '最近の作業',
    allProjects: 'すべてのプロジェクト',
    starredProjects: 'スター付きプロジェクト',
    viewAll: 'すべて表示',
    emptyState: {
      title: 'デザインが見つかりません',
      description: 'AI搭載の創造性で最初のデザインを作成しましょう',
      createButton: '新規デザインを作成',
    },
    filters: {
      all: 'すべて',
      recent: '最近閲覧したもの',
      favorites: 'お気に入り',
      public: '公開',
      private: '非公開',
    },
    sorting: {
      recentlyUpdated: '最近更新されたもの',
      oldestUpdated: '古い更新順',
      recentlyCreated: '最近作成されたもの',
      oldestCreated: '古い作成順',
      alphabetical: 'アルファベット順',
      reverseAlphabetical: '逆アルファベット順',
    },
    actions: {
      duplicate: '複製',
      rename: '名前を変更',
      delete: '削除',
      share: '共有',
      star: 'スターを付ける',
      unstar: 'スターを外す',
      moveToTrash: 'ゴミ箱に移動',
      restore: '復元',
      permanentDelete: '完全に削除',
    },
    noSearchResults: '検索結果が見つかりません',
    noSearchResultsDescription:
      "'{{query}}'に一致するデザインが見つかりませんでした。検索条件を調整してみてください。",
    clearSearch: '検索をクリア',
    noFavorites: 'お気に入りがありません',
    noDesigns: 'デザインがありません',
  },
  trash: {
    title: 'ゴミ箱',
    empty: {
      title: 'ゴミ箱は空です',
      description: 'プロジェクトを削除すると、完全に削除される前に30日間ここに表示されます。',
    },
    confirmPermanentDelete:
      'このプロジェクトを完全に削除してもよろしいですか？この操作は元に戻すことができません。',
    deletedAt: '削除日',
    restoredSuccessfully: 'プロジェクトが正常に復元されました',
    deletedPermanently: 'プロジェクトが完全に削除されました',
    failedToRestore: 'プロジェクトの復元に失敗しました',
    failedToDelete: 'プロジェクトの完全削除に失敗しました',
  },
  settings: {
    title: '設定',
    description: 'アカウントとアプリケーションの設定を管理',
    profile: {
      title: 'プロフィール',
      name: '名前',
      email: 'メールアドレス',
      enterName: 'お名前を入力してください',
      enterEmail: 'メールアドレスを入力してください',
      save: '保存',
      saving: '保存中...',
      saveProfile: 'プロフィールを保存',
      profileUpdated: 'プロフィールが更新されました',
      profileUpdatedDesc: 'プロフィールが正常に保存されました',
      saveFailed: '保存に失敗しました',
      saveFailedDesc: 'プロフィールの保存に失敗しました。もう一度お試しください。',
      changeAvatar: '変更',
      uploadingAvatar: 'アップロード中...',
      avatarUploadError: 'アップロードに失敗しました',
      avatarRequirements: 'JPG、PNG、WebP対応。最大5MB。',
      avatarError: 'アバターエラー',
      avatarSizeError: 'アバター画像は5MB以下である必要があります',
      uploadFailed: 'アップロード失敗',
      uploadFailedDesc: 'アバターのアップロードに失敗しました。もう一度お試しください。',
      avatarUpdated: 'アバターが更新されました',
      avatarUpdatedDesc: 'アバターが正常に更新されました',
      countries: {
        china: '中国',
        usa: 'アメリカ',
        uk: 'イギリス',
        japan: '日本',
        korea: '韓国',
      },
    },
    notifications: {
      title: '通知',
      email: 'メール通知',
      emailDesc: 'メールで通知を受け取る',
      desktop: 'デスクトップ通知',
      desktopDesc: 'デスクトップ通知を表示',
      marketing: 'マーケティングメール',
      marketingDesc: '製品の更新情報やヒントを受け取る',
    },
    preferences: {
      title: '設定',
      language: '言語',
      theme: 'テーマ',
      savePreferences: '設定を保存',
      settingsSaved: '設定が保存されました',
      settingsSavedDesc: '設定が正常に更新されました',
      saveFailedDesc: '設定の保存に失敗しました。もう一度お試しください。',
      autoSaved: '自動保存',
      languageChanged: '言語が変更されました',
      languageChangedDesc: '言語設定が更新されました',
    },
    account: {
      title: 'アカウント',
      changePassword: 'パスワードを変更',
      changePasswordDesc: 'アカウントのパスワードを更新',
      deleteAccount: 'アカウントを削除',
      deleteAccountDesc: 'アカウントを完全に削除',
    },
  },
  pricing: {
    seoTitle: 'Seede.ai 料金プラン - AI デザインプラットフォームの料金',
    seoDescription:
      'Seede.ai の柔軟な料金プランをご覧ください。無料プランからプロ機能まで、あなたのクリエイティブなニーズに最適な AI デザインソリューションを見つけてください。',
    seoKeywords:
      'AI デザイン料金, Seede ai プラン, AI デザインプラットフォーム, デザインツール料金',
    title: '料金プラン',
    getStarted: '始める',
    loveDesign: 'デザインが好き',
    designLikeAPro: 'プロのようにデザイン',
    designExpert: 'デザインエキスパート',
    subscribe: '購読する',
    popular: '人気',
    tryNow: '今すぐ試す',
    freePlan: '無料',
    freePlanDesc: '個人ユーザー向けの基本機能',
    freeFeatures: [
      'AI生成回数 合計5回',
      '基本的なデザイン機能',
      'コミュニティサポート',
      '無料画像処理ツール',
    ],
    starterPlan: 'スターター',
    starterPlanDesc: 'AI デザインを始めるのに最適',
    starterFeatures: [
      '200 AI クレジット（毎月更新）',
      'プレミアムデザインテンプレート',
      'メールサポート',
      'カスタムブランディング要素',
    ],
    proPlan: 'プロ',
    proPlanDesc: 'プロフェッショナルユーザー向けの高度な機能',
    proFeatures: [
      '1000 AI クレジット（毎月更新）',
      'プレミアムデザインテンプレート',
      '優先サポート',
      'カスタムブランディング要素',
    ],
    choosePlan: 'あなたのニーズに最適なプランを選択してください',
    20: {
      creditsPack: '20 AI クレジットパック',
      creditsPackDesc: '従量課金制クレジット',
      creditsFeatures: [
        '20 AI クレジット',
        '月額契約なし',
        '1年間有効',
        '基本機能',
        'すべてのデザインツールへのアクセス',
        '画像最適化ツール',
        '背景除去ツール',
        '標準カスタマーサポート',
      ],
    },
    50: {
      creditsPack: '50 AI クレジットパック',
      creditsPackDesc: '従量課金制クレジット',
      creditsFeatures: [
        '50 AI クレジット',
        '月額契約なし',
        '1年間有効',
        '高度な機能',
        'すべてのデザインツールへのアクセス',
        '画像最適化ツール',
        '背景除去ツール',
        '透かしなしHDエクスポート',
        '優先カスタマーサポート',
      ],
    },
    300: {
      creditsPack: '300 AI クレジットパック',
      creditsPackDesc: '従量課金制クレジット',
      creditsFeatures: [
        '300 AI クレジット',
        '月額契約なし',
        '1年間有効',
        'すべてのデザインツールへのアクセス',
        '画像最適化ツール',
        '背景除去ツール',
        '透かしなしHDエクスポート',
        '優先カスタマーサポート',
      ],
    },
    comingSoon: '近日公開',
    perMonth: '/月',
    betaNoticeTitle: 'ベータ版料金',
    betaNoticeDescription:
      '現在の料金プランは、ベータテストフェーズのみのものです。サービスの改善と機能の追加に伴い、将来的に価格が調整される可能性があります。',
    testimonials: {
      title: 'ユーザーレビュー',
      subtitle: 'AI で素晴らしいデザインを作成している何千人もの満足したユーザーに参加してください',
    },
    stats: {
      activeUsers: 'アクティブユーザー',
      designsCreated: '作成されたデザイン',
      satisfactionRate: '満足度',
    },
  },
  library: {
    title: 'My Libraries',
    description: 'Manage and organize your design collections',
    noLibrariesFound: 'No Libraries Found',
    noLibrariesDescription: 'Create your first library to start organizing your designs',
    untitledLibrary: 'Untitled Library',
    noDescription: 'No description',
    created: 'Created',
    loading: 'Loading libraries...',
    edit: 'Edit Library',
    create: 'Create Library',
    delete: 'Delete Library',
    name: 'Library Name',
    type: 'Type',
    editDescription: 'Description',
    category: 'Category',
    tag: 'Tags',
    html: 'HTML Content',
    save: 'Save Library',
    cancel: 'Cancel',
    confirmDelete: 'Are you sure you want to delete this library?',
    deleteSuccess: 'Library deleted successfully',
    createSuccess: 'Library created successfully',
    updateSuccess: 'Library updated successfully',
    errorLoading: 'Failed to load libraries',
  },
  libraryView: {
    backToLibraries: 'Back to Libraries',
    libraryItems: 'Library Items',
    browseItems: 'Browse items in this collection',
    emptyLibrary: 'This library is empty',
    addFirstDesign: 'Add your first design to this library',
    untitledItem: 'Untitled Item',
    loading: 'Loading library items...',
    editItem: 'Edit Item',
    deleteItem: 'Delete Item',
    confirmDelete: 'Are you sure you want to delete this item?',
    itemDeleted: 'Item deleted successfully',
    itemUpdated: 'Item updated successfully',
    errorLoading: 'Failed to load library items',
  },
  create: {
    title: '{dynamicText}を1分で作成！',
    makeA: '作成する',
    inAMinute: '1分で！',
    createTitle: '今、何をデザインしたいですか？',
    generating: '生成中...',
    promptLoading: 'デザインを作成中です。少々お待ちください...',
    library: {
      title: 'ライブラリ',
      manage: 'ライブラリを管理',
      select: 'アイテムをプレビューするライブラリを選択',
      selectAll: 'すべて',
      deselectAll: '選択解除',
      itemCount: '{{selected}}/{{total}}',
      noLibraries: 'ライブラリが見つかりません',
      preview: 'プレビュー',
      clickToSelect: 'クリックして選択',
      itemSelected: 'アイテムが選択されました',
      itemsSelected: 'アイテムが選択されました',
      addToDesign: 'デザインに追加',
      removeFromDesign: 'デザインから削除',
      dragToCanvas: 'アイテムをキャンバスにドラッグ',
      searchPlaceholder: 'ライブラリアイテムを検索...',
      createNew: '新しいライブラリを作成',
      deleteLibrary: 'ライブラリを削除',
      editLibrary: 'ライブラリを編集',
      confirmDelete: 'このライブラリを削除してもよろしいですか？',
      libraryDeleted: 'ライブラリが正常に削除されました',
      libraryCreated: 'ライブラリが正常に作成されました',
      libraryUpdated: 'ライブラリが正常に更新されました',
    },
    dynamicPlaceholders: [
      'クリーンなタイポグラフィでミニマルなポスターをデザイン...',
      '鮮やかな色彩で魅力的なソーシャルメディアバナーを作成...',
      'モダンなテクノロジープレゼンテーションスライドを生成...',
      '目を引くYouTubeサムネイルを作成...',
      'プロフェッショナルなLinkedInカバー画像をデザイン...',
    ],
    generateMode: {
      title: '生成モード',
      fast: '高速',
      workflow: 'ワークフローモード',
      fastDescription: '高速生成、パフォーマンスとバランスの取れた視覚要素に最適化',
      workflowDescription: '高度な生成モード、時間はかかりますがより高品質な結果',
    },
    deviceNotSupportedTitle: 'デバイスがサポートされていません',
    deviceNotSupportedDesc:
      '最高の体験のために、デスクトップコンピューターを使用してください。モバイルデバイスは現在サポートされていません。',
    colorScheme: 'カラースキーム',
    esmNotSupportedTitle: 'ブラウザがサポートされていません',
    esmNotSupportedDesc:
      'お使いのブラウザは必要な機能をサポートしていません。Chrome、Edge、Safariなどの最新ブラウザを使用してください。',
    inputRequiredTitle: '入力が必要です',
    inputRequired: '入力が必要です',
    inputRequiredDesc: '続行するには、テキストの説明を入力するか画像をアップロードしてください。',
    projectCreationFailed: 'プロジェクト作成に失敗しました',
    projectCreationErrorDesc:
      'プロジェクトの作成中にエラーが発生しました。もう一度お試しください。',
    uploadError: '素材のアップロードに失敗しました。もう一度お試しください',
    parseError: 'コンテンツの解析に失敗しました',
    maxImagesReached: '画像数の上限に達しました',
    maxImagesReachedDesc: '最大 {{max}} 枚の画像を追加できます',
    maxTagsReached: 'タグ数の上限に達しました',
    maxTagsReachedDesc: '最大 {{max}} 個のタグを追加できます',
    maxColorsReached: 'カラー数の上限に達しました',
    maxColorsReachedDesc: '最大 {{max}} 個のカラータグを追加できます',
    tryAgain: 'もう一度試す',
    uploadImage: '画像をアップロード',
    attach: '添付',
    attachTips: 'より正確なデザイン結果のために参考画像をアップロード',
    addMaterial: '素材を追加',
    addMaterialTips: '画像素材をデザインに追加',
    generate: '生成',
    singleMode: '単一',
    batchMode: 'バッチ',
    generateBatch: 'バッチ生成',
    giveInspirationPrompt: 'インスピレーションを得る',
    dynamicTextOptions: ['ポスター', 'バナー', 'ミーム'],
    promptPlaceholder:
      'デザインのアイデアを説明してください（例：「コーヒーショップ用のモダンなポスター」）',
    modelLabel: 'モデルを選択：',
    sizeLabel: 'サイズを選択：',
    use: '使用',
    presetTitle: 'またはプリセットプロンプトを選択：',
    loginRequired: 'ログインが必要です',
    loginMessage: 'Seede AI へようこそ',
    continueWithEmail: 'メールで続行',
    continueWithPhone: '電話番号で続行',
    loginButton: 'ログイン',
    registerButton: '登録',
    maybeLater: '後で',
    referenceUrl: '参照URL',
    enterReferenceUrl: '参照URLを入力',
    multimodal: 'マルチモーダル',
    whatToCreateToday: '今日は何を作成しますか？',
    sizes: {
      height: '高さ',
      width: '幅',
      custom: 'カスタム',
      wechatMpCover: 'WeChat投稿',
      mobilePoster: 'モバイルポスター',
      redNote: 'Red',
      infographic: 'インフォグラフィック',
      instagram: 'Instagram',
      facebook: 'Facebook投稿',
      twitter: 'Twitter投稿',
      linkedin: 'LinkedIn投稿',
      pinterest: 'Pinterestピン',
      youtube: 'YouTubeサムネイル',
      tvScreen: 'TVスクリーン',
      a4: 'A4用紙',
      a5: 'A5用紙',
      businessCard: '名刺',
      postcard: 'ポストカード',
      flyer: 'チラシ',
      brochure: 'パンフレット',
      poster: 'ポスター',
      banner: 'バナー',
      billboard: 'ビルボード',
      menu: 'メニュー',
      rollUpBanner: 'ロールアップバナー | 80×200cm',
      tableCard10x15: 'テーブルカード | 10×15cm',
      tableCard15x20: 'テーブルカード | 15×20cm',
      lightBoxPoster: 'ライトボックスポスター | 60×90cm',
      a2: 'A2用紙',
      a3: 'A3用紙',
    },
    custom_size: {
      title: 'カスタムサイズを作成',
      name: '名前（オプション）',
      name_placeholder: 'マイカスタムサイズ',
      width: '幅（px）',
      height: '高さ（px）',
      cancel: 'キャンセル',
      create: '作成',
    },
    size_categories: {
      social: 'ソーシャルメディア',
      print: '印刷・デバイス',
      aspect: 'アスペクト比',
      custom: 'カスタムサイズ',
      add_custom: 'カスタムサイズを追加',
    },
    credits: 'クレジット',
    guide: 'さらにクレジットを取得',
    projectType: {
      public: {
        label: '公開',
        description: '誰でも閲覧・リミックス可能',
      },
      private: {
        label: '非公開',
        description: 'プライベートで作成・デザイン',
        tag: 'Pro',
      },
    },
    mobileWarning: {
      title: 'モバイルはサポートされていません',
      message: 'デスクトップブラウザをご利用ください',
      button: '了解',
    },
    insufficientCredits: {
      title: 'クレジット不足',
      description:
        'すべてのクレジットを使用しました。友達を招待してさらにクレジットを取得しましょう！',
    },
    batch: {
      design: 'デザイン',
      designs: 'デザイン',
      generateOne: '1つのデザインを生成',
      generateMultiple: '{{count}}個のデザインを生成',
      title: 'バッチ生成',
      description:
        '一度に複数のデザインバリエーションを生成して、さまざまなクリエイティブな方向性を探索。',
      hint: 'デザインの数が多い = よりクリエイティブなオプション',
    },
    promptTemplates: 'プロンプト',
    recentProjects: 'マイプロジェクト',
    latestTemplates: '最新テンプレート',
    featuredProjects: '注目プロジェクト',
    viewAll: 'すべて表示',
    viewMore: 'さらに表示',
    view: '表示',
    open: '開く',
    noRecentProjects: '最近のプロジェクトが見つかりません',
    firstDesign: 'テンプレートを選択するかAI生成を使用して最初のデザインを作成しましょう',
    noTemplates: '利用可能なテンプレートがありません',
    noFeaturedProjects: '注目のデザインはありません',
    checkBackLater: 'コミュニティから新しい注目のデザインを後で確認してください',
    colorSchemes: {
      defalt: 'デフォルトカラースキーム',
      monochrome: 'モノクローム',
      business: 'ビジネスプロフェッショナル',
      cafe: 'コーヒー＆カフェ',
      restaurant: 'レストラン',
      vintage: 'ビンテージ',
      modern: 'モダンコーポレート',
      nature: '自然',
      luxury: 'ラグジュアリー',
      tech: 'テクノロジー',
      pastel: 'パステル',
      retro: 'レトロ',
      custom: 'カスタムカラー',
    },
  },
  features: {
    title: '機能',
    categories: {
      aiDesign: 'AIデザイン',
      getSeede: 'Seede入手',
      tutorials: 'チュートリアル',
    },
    comingSoon: '近日公開',
    features: {
      templates: {
        title: 'テンプレート',
        description: 'プロフェッショナルにデザインされたテンプレートライブラリを探索',
        action: 'テンプレートから作成を開始',
      },

      textToDesign: {
        title: 'テキストからデザイン',
        description: 'テキストプロンプトからデザインを生成',
        action: '作成を開始',
      },
      imageToDesign: {
        title: '画像からデザイン',
        description: '参考画像からデザインを作成',
      },
      designIteration: {
        title: 'デザイン反復',
        description: 'AI搭載のデザイン改良と最適化',
      },
      batchGeneration: {
        title: 'バッチ生成',
        description: '異なるバリエーションで複数のデザインを一度に生成',
      },
      updates: {
        title: '更新',
        description: '手動チェックオプション付きの自動更新',
      },
      createDesignBoard: {
        title: 'デザインボード作成',
        description: 'AIデザインツールで新しいプロジェクトを開始',
      },
      textToPoster: {
        title: 'テキストからポスター',
        description: 'テキスト説明からポスターを生成',
      },
      imageToPoster: {
        title: '画像からポスター',
        description: '参考画像から編集可能なデザインを作成',
      },
    },
  },
  imageGenerator: {
    title: 'AI画像ジェネレーター',
    subtitle: 'テキストを数秒で美しい画像に変換',
    prompt: {
      label: 'プロンプト',
      placeholder: '生成したい画像を説明してください...',
      enhance: 'プロンプト強化',
      enhancing: '強化中...',
      getInspiration: 'インスピレーションを得る',
      clear: 'クリア',
    },
    history: '履歴',
    historyDialog: {
      title: '履歴',
      description: '過去の画像生成を表示します。',
    },
    generate: '生成',
    stylePreset: 'スタイルプリセット',
    moreOptions: 'その他のオプション',
    createFirst: {
      title: '最初の画像を作成',
      description:
        'アイデアを美しいビジュアルに変換します。作成したいものを説明するだけで、AIが魔法をかけます。',
      tryExample: 'サンプルプロンプトを試す →',
      outputSize: '出力サイズ:',
    },
    errors: {
      missingPrompt: {
        title: 'プロンプトが不足',
        description: '画像を生成するにはプロンプトが必要です。',
      },
      generic: {
        title: 'おっと！何かがうまくいきませんでした。',
      },
    },
  },
  useCases: {
    title: '使用例',
    description:
      'Seede AIがこれらの強力な使用例でクリエイティブワークフローをどのように変革できるかを探索',
    seoTitle: 'AIデザイン使用例 | Seede AI',
    seoDescription:
      'Seede AIがソーシャルメディア、ポスター、ニュースレターなどの美しいデザインをAI搭載のデザインツールでどのように作成できるかを発見してください。',
    seoKeywords:
      'AIデザイン, デザイン使用例, ソーシャルメディア投稿, ポスター, ニュースレター, ポッドキャストカバー, フラッシュカード, 動画サムネイル',
    learnMore: '詳細を見る',
    tryNow: '今すぐ試す',
    socialMedia: {
      title: 'ソーシャルメディア投稿',
      description: 'Seede AIで魅力的なソーシャルメディアコンテンツを作成',
    },
    minimalistPoster: {
      title: 'ミニマリストポスター',
      description:
        'プロフェッショナルなレイアウトでクリーンでモダンなミニマリストポスターをデザイン',
    },
    letterCard: {
      title: 'レターカード',
      description: 'エレガントなタイポグラフィとレイアウトで美しいレタースタイルカードを作成',
    },
    podcastCover: {
      title: 'ポッドキャストカバー',
      description: 'Apple風の美学で目を引くポッドキャストカバーアートをデザイン',
    },
    videoCover: {
      title: '動画カバー',
      description: 'Notionスタイルのミニマリズムでプロフェッショナルな動画サムネイルを作成',
    },
    flashCard: {
      title: 'フラッシュカード',
      description: '明確なレイアウトで効果的な語彙と学習フラッシュカードをデザイン',
    },
    newsletter: {
      title: 'ニュースレター',
      description:
        'クリーンなタイポグラフィと画像でプロフェッショナルなニュースレターデザインを作成',
    },
  },
  batchMode: {
    title: 'バッチプロジェクトプレビュー',
    description:
      'バッチ作成が完了しました！あなたのビジョンに最も適したデザインをレビューして選択してください。任意のプロジェクトをクリックして、さらに詳しく探索し改良できます。',
    startAnotherBatch: '別のバッチを開始',
    foundPerfectDesign: '完璧なデザインが見つかりましたか？',
    emptyStateTitle: 'バッチデザインがまだありません',
    emptyStateDescription:
      '作成ページからバッチ生成を開始して、一度に複数のデザインバリエーションを作成してください。',
    startCreating: '作成を開始',
    regenerate: '再生成',
    yourPrompt: 'あなたのプロンプト',
    edit: '編集',
    status: {
      pending: '待機中',
      generating: '生成中',
      completed: '完了',
      error: 'エラー',
    },
  },
  designError: {
    title: 'デザインにアクセスできません',
    messages: {
      Forbidden:
        'このプロジェクトを表示する権限がありません。プライベートに設定されているか、削除された可能性があります。',
      NetworkError:
        'リソースの取得中にネットワークエラーが発生しました。インターネット接続を確認して、もう一度お試しください。',
      NotFound:
        'リクエストされたリソースが見つかりませんでした。URLを確認して、もう一度お試しください。',
      Unauthorized:
        'このリソースにアクセスする権限がありません。ログインするか、サポートに連絡してください。',
      ServerError:
        'サーバーでエラーが発生しました。しばらくしてからもう一度お試しいただくか、サポートに連絡してください。',
    },
    errorDetails: 'エラー詳細',
    returnHome: 'ホームに戻る',
    errorIcon: 'エラーアイコン',
  },
  preview: {
    title: 'プレビュー',
    share: '共有',
    description: 'デザインをプレビューして編集',
    back: '作成に戻る',
    export: 'エクスポート',
    createNew: '新規作成',
    readonly: '読み取り専用',
    chat: 'チャット',
    edit: '編集',
    layers: 'レイヤー',
    images: '画像',
    text: 'テキスト',
    library: 'ライブラリ',
    dragToCanvas: 'キャンバスにドラッグ',
    send: '送信',
    sending: '送信中...',
    sendShortcut: 'Shift + Enterで送信',
    credits: 'クレジット',
    typeMessage: 'メッセージを入力...',
    tokensGenerated: '{{count}} トークンが生成されました',
    generationComplete: '✅ デザイン生成完了！',
    savingMasterpiece: '💾 あなたの傑作を保存中...',
    generationError: '🔄 おっと！何かがうまくいきませんでした。もう一度試してみます...',
    somethingWrong: '申し訳ありませんが、何かがうまくいきませんでした。もう一度お試しください。',
    timeoutError:
      'デザインのレンダリング待機がタイムアウトしました。これは通常、生成されたコードに構文エラーがある場合に発生します。',
    seedeRootError:
      'デザインが正しくレンダリングできませんでした。複雑な要素やブラウザの制限が原因の可能性があります。',
    tryAgainSimpler:
      'より簡単なデザインリクエストでもう一度お試しいただくか、ページを更新してください。',
    needMoreCredits: '続行するにはより多くのクレジットが必要です',
    getMoreCredits: 'クレジットを購入',
    inviteForCredits: '無料クレジットを取得',
    upgradeAccount: '無制限アクセスのためにアカウントをアップグレード',
    creditsExhausted: 'クレジットが使い切られました',
    freeCreditsAvailable: '友達を招待して5つの無料クレジットを取得',
    limitReached: '使用制限に達しました',
    continueWithCredits: 'クレジットを追加して、素晴らしいデザインの作成を続ける',
    generationCompleted: '生成完了',
    designingPoster: '🎨 Seede AIがあなたのポスターをデザイン中...',
    copy: 'コピー',
    regenerate: '再生成',
    task: {
      analysis: '要件分析',
      typography: 'タイポグラフィ',
      style: 'デザインスタイル',
      layout: 'ページレイアウト',
      code: 'デザイン構築',
      build: 'デザイン合成',
      image: '画像処理',
    },
    snapshot: {
      title: 'プロジェクトスナップショット',
      description: 'プロジェクトバージョンのスナップショット',
      noPreviewAvailable: 'プレビューが利用できません',
      restoreSnapshot: 'このバージョンを復元',
      viewSnapshot: 'スナップショットを表示',
      snapshotDescription: 'プロジェクトバージョンのスナップショット',
      restoreConfirm: 'このバージョンを復元してもよろしいですか？',
      restoreSuccess: 'バージョンが正常に復元されました',
      restoreFailed: 'デザインバージョンの復元に失敗しました。',
      created: 'スナップショットが作成されました',
      loading: 'スナップショットを読み込み中...',
    },
    chatMessage: {
      copyToClipboard: 'クリップボードにコピー',
      copySuccess: 'クリップボードにコピーしました',
      copySuccessDescription: 'テキストが正常にコピーされました',
      copyFailed: 'コピーに失敗しました',
      copyFailedDescription: 'テキストをクリップボードにコピーできませんでした',
    },
  },
  exportMenu: {
    title: 'エクスポート設定',
    description: 'エクスポート用のフォーマットと品質を選択',
    exportImage: 'エクスポート',
    copyToClipboard: 'クリップボードにコピー',
    selectPage: 'ページを選択',
    choosePage: 'エクスポートするページを選択',
    fileFormat: 'ファイル形式',
    exportAll: 'すべてエクスポート',
    exportAllPages: 'すべてのページを一度にエクスポート',
    selectFormat: 'フォーマットを選択',
    pngFormat: 'PNG（高品質）',
    jpgFormat: 'JPG（圧縮）',
    webpFormat: 'WebP（モダンフォーマット）',
    pdfFormat: 'PDF（ドキュメント形式）',
    htmlFormat: 'HTML',
    resolution: '解像度',
    selectResolution: '解像度を選択',
    standard: '標準（1x）',
    highRes: '高解像度（2x）',
    ultraHighRes: '超高解像度（3x）',
    extremeHighRes: '極高解像度 ({{value}}x)',
    printOptimized: '印刷最適化',
    dpi: 'DPI（ドット・パー・インチ）',
    selectDpi: 'DPIを選択',
    cmykColorSpace: 'CMYKカラースペース',
    cmykDescription: 'プロフェッショナル印刷用に最適化',
    copiedToClipboard: 'クリップボードにコピーしました',
    copySuccess: '画像がクリップボードに正常にコピーされました',
    copiedAs: '{{format}} としてコピーしました',
    exporting: 'エクスポート中...',
    preparingDownload: 'ダウンロードを準備中...',
    downloadComplete: 'ダウンロードの準備ができました',
    downloadFailed: 'ダウンロードに失敗しました。もう一度お試しください。',
    success: '成功',
    printSize: '印刷サイズ（cm）',
    error: 'エラー',
    cmykMode: 'CMYKカラースペース',
    printOptimizedDescription: 'プロフェッショナル印刷用に最適化',
    multiplePages: '複数ページ',
    allPages: 'すべてのページ',
    currentPage: '現在のページ',
    downloadStarted: 'ダウンロードを開始しました',
    processingFiles: 'ファイルを処理中...',
    viewingDistance: {
      veryFar: '看板や非常に大きなフォーマット用（10m+）',
      far: '遠距離での閲覧用（3-10m）',
      medium: '通常の閲覧距離用（1-3m）',
      close: '近距離での検査用（0.3-1m）',
      detailed: '詳細なプロフェッショナル印刷用（0.3m未満）',
    },
    sizeTable: {
      title: '標準用紙サイズ参照表',
      format: 'フォーマット',
      width: '幅',
      height: '高さ',
      dimensions: 'cm',
      clickToApply: 'このサイズを適用するにはクリック',
      customSize: 'カスタムサイズ',
    },
    copyNotSupported: 'コピーがサポートされていません',
    copyNotSupportedDesc: 'お使いのブラウザは画像のクリップボードへのコピーをサポートしていません',
  },
  signIn: {
    title: 'サインイン',
    createYourAccount: 'アカウントを作成',
    signUp: 'サインアップ',
    signIn: 'サインイン',
    welcomeBack: 'おかえりなさい！',
    joinToday: '今日Seede.aiに参加',
    accessTools: 'デザインスキル不要で数分で魅力的なビジュアルを作成。',
    email: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力',
    inputPlaceholder: '入力してください',
    continueWith: '次で続行',
    continueWithEmail: 'メールで続行',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力',
    confirmPassword: 'パスワード確認',
    smsCode: '認証コード',
    emailCode: '認証コード',
    confirmPasswordPlaceholder: 'パスワードを確認',
    inviteCode: '招待コード（任意）',
    inviteCodePlaceholder: '招待コードを入力',
    loginButton: 'サインイン',
    registerButton: 'サインアップ',
    noAccount: 'アカウントをお持ちでない方はサインアップ',
    hasAccount: 'すでにアカウントをお持ちの方はサインイン',
    loginFailed:
      'ログインに失敗しました。メールアドレスとパスワードを確認してもう一度お試しください。',
    networkError: 'ネットワークエラー',
    orContinueWith: 'または次で続行',
    passwordMismatch: 'パスワードが一致しません',
    agreeToTerms: '「Googleで続行」またはサインアップをクリックすることで、私たちの',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    and: 'および',
    forgotPassword: 'パスワードをお忘れですか？',
    agreeToTermsRequired: '続行するには利用規約とプライバシーポリシーに同意してください',
    messages: {
      6001: 'メールアドレスは既に存在します',
      6002: '無効なメールアドレスまたはパスワード',
      6003: 'パスワードが短すぎます',
      6004: '無効なメールアドレス',
      6005: '一時的なメールアドレスは許可されていません',
    },
  },
  forgotPassword: {
    seoTitle: 'パスワードリセット - Seede AI',
    seoDescription:
      'Seede.aiアカウントのパスワードを安全にリセット。メールアドレスを入力して認証コードを受け取り、新しいパスワードを作成してください。',
    seoKeywords: 'パスワードリセット,パスワード忘れ,パスワード復旧,seede ai,アカウント復旧',
    title: 'パスワードをお忘れですか？',
    description: 'メールアドレスを入力すると、パスワードリセット用の認証コードをお送りします。',
    resetTitle: 'パスワードをリセット',
    resetDescription:
      '{{email}}に認証コードを送信しました。以下にコードと新しいパスワードを入力してください。',
    verificationCode: '認証コード',
    codePlaceholder: '6桁のコードを入力',
    newPassword: '新しいパスワード',
    newPasswordPlaceholder: '新しいパスワードを入力（最低6文字）',
    sendCode: '認証コードを送信',
    sending: '送信中...',
    resetButton: 'パスワードをリセット',
    resetting: 'リセット中...',
    backToSignIn: '← サインインに戻る',
    backToEmail: '← メールに戻る',
    successTitle: 'パスワードリセット成功！',
    successDescription:
      'パスワードが正常にリセットされました。新しいパスワードでサインインできます。',
    signInNow: '今すぐサインイン',
    sideTitle: '安全なパスワード復旧',
    sideDescription:
      'パスワードを安全にリセットして、Seede.aiで素晴らしいデザインの作成に戻りましょう',
    emailRequired: 'メールアドレスを入力してください',
    invalidEmail: '有効なメールアドレスを入力してください',
    sendCodeFailed: '認証コードの送信に失敗しました。もう一度お試しください。',
    codeRequired: '認証コードを入力してください',
    passwordRequired: '新しいパスワードを入力してください',
    passwordTooShort: 'パスワードは最低6文字である必要があります',
    passwordMismatch: 'パスワードが一致しません',
    resetFailed: 'パスワードリセットに失敗しました。もう一度お試しください。',
  },
  designHeaderMenu: {
    back: '戻る',
    view: '表示',
    zoomIn: '拡大',
    zoomOut: '縮小',
    zoomToFit: '画面に合わせる',
    shortcuts: 'キーボードショートカット',
    help: 'ヘルプ',
    docs: 'ドキュメント',
    support: 'サポート',
    untitled: '無題',
    readonly: '読み取り専用',
    export: 'エクスポート',
    project: 'プロジェクト',
    makePublic: '公開にする',
    makePrivate: '非公開にする',
    visibility: '公開設定',
    public: '公開 - リンクを知っている人は誰でも閲覧できます',
    private: '非公開 - あなたのみ閲覧できます',
    visibilitySuccess: 'プロジェクトの公開設定を更新しました',
    visibilitySuccessDesc: 'あなたのプロジェクトは{{visibility}}になりました',
    visibilityFailed: '公開設定の変更に失敗しました',
    visibilityFailedDesc:
      'プロジェクトの公開設定を変更中にエラーが発生しました。後でもう一度お試しください。',
  },
  templates: {
    title: 'Templates',
    description: 'Explore our collection of professionally designed templates',
    loading: 'Loading templates...',
    filter: 'Filter by tag',
    allTags: 'All tags',
    noTemplates: 'No templates found',
    createFromTemplate: 'Create from template',
    backToAllTemplates: 'Back to All Templates',
    allTemplates: 'All Templates',
    categories: 'Categories',
    viewAll: 'View All',
    browseByCategory: 'Browse By Category',
    recentlyUpdated: 'Recently Updated',
  },
  templateDetail: {
    title: 'Template Details',
    backToTemplates: 'Back to Templates',
    useTemplate: 'Use This Template',
    loading: 'Loading template...',
    description: 'Description',
    tags: 'Tags',
    copyPrompt: 'Copy Prompt',
    remix: 'Remix',
    creating: 'Creating...',
    relatedTemplates: 'Related Templates',
    templateInfo: 'Template Information',
    dimensions: 'Dimensions',
    category: 'Category',
    createdBy: 'Created By',
    dateCreated: 'Date Created',
    lastModified: 'Last Modified',
    templateStats: 'Template Stats',
    usageCount: 'Usage Count',
    favoriteCount: 'Favorite Count',
    shareTemplate: 'Share Template',
    downloadTemplate: 'Download Template',
    similarTemplates: 'Similar Templates',
    editTemplate: 'Edit Template',
    previewTemplate: 'Preview Template',
    templateVersion: 'Version',
    templateSize: 'File Size',
    templateFormat: 'Format',
    prompt: 'Prompt',
    promptCopied: 'Prompt copied to clipboard!',
    copyPromptError: 'Failed to copy prompt',
    editContent: 'Edit Content',
    contentSpecifications: 'Content Specifications',
    model: 'Model',
    universal: 'Universal',
    version: 'Version',
    created: 'Created',
    updated: 'Updated',
    content: 'Content',
    moreElements: '+ {{count}} more elements',
    useOriginalPrompt: 'Use Original Prompt',
    chooseImage: 'Choose image',
    variable: 'Variable {{index}}',
    enterText: 'Enter text',
    copyToClipboard: 'Copy to clipboard',
  },
  templatesTag: {
    title: 'Templates by Tag',
    description: 'Explore templates filtered by specific tags',
    noTemplatesFound: 'No templates found with this tag',
    loading: 'Loading tagged templates...',
    viewAllTemplates: 'View All Templates',
    taggedWith: 'Templates tagged with {{tag}}',
  },
  help: {
    title: 'Help Center',
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        question: 'How to get started with Seede.ai?',
        answer:
          'You can start using Seede.ai by registering an account and logging in. We provide an easy-to-use interface and tutorials to help you get started quickly.',
      },
      {
        question: 'What file formats does Seede.ai support?',
        answer: 'We support common image formats such as JPG, PNG, SVG, and Webp.',
      },
      {
        question: 'How to upgrade to the Pro version?',
        answer:
          'You can find the upgrade option in your account settings and choose a subscription plan that suits you.',
      },
      {
        question: 'How to get technical support?',
        answer:
          'You can check our help documentation or contact our technical support team at hi@seede.ai.',
      },
      {
        question: 'How to export my designs?',
        answer:
          'After editing, click the export button in the top right corner and select your desired format（PNG/PDF/JPG） and resolution to download.',
      },
      {
        question: 'Can I collaborate with team members on Seede.ai?',
        answer:
          "Currently, Seede.ai doesn't support collaboration features. We're working on adding team collaboration functionality in a future update.",
      },
      {
        question: 'Is there a mobile app for Seede.ai?',
        answer: 'Currently, Seede.ai is optimized for desktop use.',
      },
      {
        question: 'Can I use Seede.ai for commercial projects?',
        answer:
          'Absolutely! Seede.ai can be used for both personal and commercial projects. Our Pro version offers additional features for professional use.',
      },
      {
        question: 'Do you offer custom templates for specific industries?',
        answer:
          'Yes, we provide a wide range of templates categorized by industry and use case. You can also request custom templates through our support channel.',
      },
      {
        question: 'How often are new features added to Seede.ai?',
        answer:
          'We regularly update Seede.ai with new features and improvements. We release major updates quarterly and smaller enhancements monthly.',
      },
      {
        question: 'Can I cancel my subscription at any time?',
        answer:
          'Yes, you can cancel your subscription at any time from your account settings. Your access will continue until the end of your billing period.',
      },
    ],
    contactTitle: 'Need more help?',
    contactDescription:
      "If the FAQs don't solve your problem, please contact us through the following methods:",
    contactEmail: 'Email: hi@seede.ai',
    workingHours: 'Working hours: Monday to Friday 9:00 - 18:00',
  },
  notFound: {
    title: 'Page Not Found',
    description: "The page you're looking for doesn't exist or has been moved.",
    goHome: 'Go Back Home',
  },
  contact: {
    title: 'Contact Us',
    getInTouch: 'Get in Touch',
    contactDescription: 'For any inquiries or support, please contact us at:',
    contactInfo: 'Contact Info',
    email: 'Email: hi@seede.ai',
    socialMedia: 'Social Media',
    followUs: 'Follow us for updates',
    twitterHandle: '@seedeAI',
    support: 'Support',
    supportDescription: 'Need help with our products?',
    business: 'Business',
    businessDescription: 'For partnerships & opportunities',
    contactEmail: 'hi@seede.ai',
  },
  tools: {
    title: 'Tools',
    mainProduct: '🎨 Seede AI',
    mainProductDesc: 'AI-powered design tool for social media and marketing',
    text2image: '✨ Text to Image',
    text2imageDesc: 'Generate images from text descriptions',
    video: '🎥 Landscape to Portrait Video Tool',
    videoDesc: 'Convert landscape videos to portrait format for social media',
    imageProcessing: '🖼️ Image Processing',
    imageProcessingDesc: 'Edit and enhance your images',
    imageGeneration: '🎨 Image Generation',
    imageGenerationDesc: 'Create AI-generated images',
    imageUpscaling: '⚡ Image Upscaling',
    imageUpscalingDesc: 'Enhance image resolution and quality',
    backgroundRemoval: '✂️ Background Removal',
    backgroundRemovalDesc: 'Remove image backgrounds automatically',
    magicEraser: '🪄 Magic Eraser',
    magicEraserDesc: 'Remove unwanted objects from images',
    playground: '🧩 Code to Canvas Playground',
    playgroundDesc: 'Convert HTML/React/SVG to canvas and experiment with designs',
    playgroundTitle: 'Code to Canvas Playground',
    playgroundSubtitle: 'Experiment with HTML/React/SVG and see it rendered on canvas',
    playgroundFeatures: 'Interactive design environment with real-time preview',
    playgroundUsage: 'Great for prototyping and testing design ideas',
  },
  videoTool: {
    title: '🎥 Landscape to Portrait Video Tool',
    description: 'Convert landscape videos to portrait format for social media',
    uploadVideo: 'Upload Video',
    uploadVideoDesc: 'Supports common formats like MP4, WebM',
    uploadBackground: 'Upload Background Image',
    uploadBackgroundDesc: 'Supports JPG, PNG and other common formats',
    clickToUploadVideo: 'Click to upload video',
    clickToUploadBackground: 'Click to upload background image',
    bitrate: 'Bitrate',
    encoder: 'Encoder',
    processing: 'Processing...',
    processProgress: 'Processing Progress',
    timeElapsed: 'Time Elapsed: {{time}}s',
    startMerge: 'Start',
    errorMessages: {
      uploadRequired: 'Please upload video and background image',
      resolutionTooHigh:
        'Video resolution is too high, please use lower resolution video or select higher encoding level',
      processFailed: 'Video processing failed, please try again',
    },
  },
  invite: {
    title: '友達を招待',
    guide: 'クレジットを追加',
    credits: 'クレジット',
    succeededDescription: '認証成功、5クレジット付与',
    pending: '認証待ち',
    pendingDescription: 'メール認証待ち',
    subtitle: 'あなたと友達の両方に5クレジットが付与されます！',
    description:
      '友達があなたの招待リンクを使って登録し、アカウントを認証すると、双方に5クレジットが付与されます。',
    inviteLink: '招待リンク',
    copyLink: 'リンクをコピー',
    copySuccess: 'コピーしました',
    copyDescription: '招待リンクがクリップボードにコピーされました',
    records: '招待履歴',
    recordCount: '合計 {{count}} 件',
    noRecords: '招待履歴がありません',
    noRecordsDesc: '招待リンクを共有すると履歴が表示されます',
    user: 'ユーザー',
    registered: '登録済み',
    usage: '使用状況',
    usageDescription: 'Used',
  },
  profile: {
    title: 'My Profile',
    usage: 'Usage',
    usageDescription: 'Credits Used',
    buyCredits: 'Get Credits Now',
    inviteFriends: 'Invite & Earn Credits',
    recentProjects: 'Recent Projects',
    viewAll: 'View All',
    createNew: 'Create New Project',
    sendVerification: 'Send Email verification',
    editProfile: 'Edit Profile',
    changeAvatar: 'Change Avatar',
    displayName: 'Display Name',
    bio: 'Bio',
    bioPlaceholder: 'Tell us about yourself',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    profileUpdated: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    characterLimit: '{{current}}/{{max}} characters',
    avatarUploadFailed: 'Failed to upload avatar',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    loadMore: 'Load More Projects',
    notFound: 'User Not Found',
    notFoundDesc: 'The user profile you are looking for does not exist or may have been removed.',
    backHome: 'Back to Home',
    noProjects: 'No Public Projects Yet',
    noProjectsDesc: 'This user has not published any public projects yet. Check back later!',
  },
  success: {
    title: 'Payment Successful!',
    description: 'Your payment has been processed successfully. Thank you for your purchase.',
    dashboard: 'Go to Dashboard',
    createNew: 'Create New Design',
  },
  dashboard: {
    RecentDesigns: 'Recent Designs',
    ShowAll: 'Show All',
    ShowStarred: 'Show Starred',
    NewDesign: 'New design',
    CreateNewProject: 'Create New Project',
    LoadingProjects: 'Loading projects...',
    WelcomeTitle: 'Welcome to Seede',
    WelcomeDescription:
      'Click the button below to add a new design project and start your creative journey.',
    NoProjects: 'No projects yet',
    StarredProjects: 'Starred Projects',
  },
  project: {
    open: 'Open',
    duplicate: 'Duplicate',
    delete: 'Delete',
    star: 'Star',
    unstar: 'Unstar',
    rename: 'Rename',
    lastEdited: 'Last edited',
    untitled: 'Untitled Project',
    confirmDelete: 'Are you sure you want to delete this project?',
    deleteSuccess: 'Project deleted successfully',
    duplicateSuccess: 'Project duplicated successfully',
  },
  auth: {
    emailVerificationRequired: 'Email Verification Required',
    verificationDescription: "Please verify your email address. We've sent a verification link to:",
    resendVerificationEmail: 'Resend Verification Email',
    sending: 'Sending...',
    verificationEmailSent: 'Verification email sent successfully!',
    checkInbox: 'Please check your inbox and spam folder for the verification email.',
    verificationEmailFailed: 'Failed to send verification email',
    tryAgainLater: 'Please try again later or contact support if the problem persists.',
    close: 'Close',
    login: 'Login',
    signup: 'Sign Up',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    loginSuccess: 'Login successful!',
    signupSuccess: 'Sign up successful!',
    passwordResetSuccess: 'Password reset successful!',
    passwordResetRequest: 'Password reset link sent to your email',
    invalidCredentials: 'Invalid email or password',
    accountExists: 'Account already exists with this email',
    accountNotFound: 'No account found with this email',
    passwordMismatch: 'Passwords do not match',
    requiredField: 'This field is required',
  },
  posterStyles: {
    default: 'Style',
    service: 'Service Oriented',
    beauty: 'Beauty & Cosmetics',
    lifestyle: 'Lifestyle & Wellness',
    fashion: 'Fashion Forward',
    minimalist: 'Minimalist',
    lightshadow: 'Light & Shadow',
    gradient: 'Gradient Flow',
    vintage: 'Vintage Retro',
    geometric: 'Geometric Abstract',
    neon: 'Neon Glow',
    organic: 'Organic Nature',
    typographic: 'Typography Focus',
    isometric: 'Isometric 3D',
    glassmorphism: 'Glass Morphism',
    brutalism: 'Digital Brutalism',
  },
  resize: {
    title: 'Image Resize Tool',
    description: 'Resize your images to any dimension while maintaining quality',
    uploadImage: 'Upload Image',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Resize Settings',
    dimensions: 'Dimensions',
    width: 'Width',
    height: 'Height',
    maintainAspectRatio: 'Maintain aspect ratio',
    format: 'Format',
    quality: 'Quality',
    resize: 'Resize Image',
    processing: 'Processing...',
    reset: 'Reset',
    result: 'Result',
    download: 'Download Resized Image',
    noImageSelected: 'Please select an image first',
    processingError: 'Error processing image. Please try again.',
    imageLoadError: 'Error loading image. Please try a different file.',
  },
  border: {
    title: 'Image Border Tool',
    description:
      'Add a border to your pictures to make them stand out and win more likes on social media',
    uploadImage: 'Upload Image',
    livePreview: 'Live Preview',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Border Settings',
    width: 'Border Width',
    color: 'Border Color',
    style: 'Border Style',
    radius: 'Border Radius',
    format: 'Format',
    quality: 'Quality',
    apply: 'Apply Border',
    processing: 'Processing...',
    reset: 'Reset',
    result: 'Result',
    download: 'Download ',
    noImageSelected: 'Please select an image first',
    processingError: 'Error processing image',
    imageLoadError: 'Error loading image',
  },
  removeBg: {
    title: 'Background Removal Tool',
    description: 'Remove background from your images with one click using AI technology',
    uploadImage: 'Upload Image',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Output Settings',
    format: 'Format',
    quality: 'Quality',
    removeBackground: 'Remove Background',
    processing: 'Processing...',
    download: 'Download',
    reset: 'Reset',
    result: 'Result',
    preview: 'Preview',
    noImageSelected: 'Please select an image first',
    processingError: 'Error removing background from image',
    resultNote: 'Background has been removed. You can now download the image.',
    previewNote: "Click 'Remove Background' to process this image",
    rembg: 'Remove Background',
  },
  feedback: {
    title: 'How would you rate this AI-generated design?',
    thankYou: 'Thank you for your feedback!',
    goodQuality: 'Good',
    average: 'Average',
    poorQuality: 'Poor',
    submitSuccess: 'Feedback submitted successfully',
    submitError: 'Error submitting feedback. Please try again.',
    prompt: 'How would you rate this AI-generated design?',
    description: 'Your feedback helps us improve the AI design experience',
    poorQualityExplanation:
      'Poor generation quality may be due to unclear requirements or model limitations. Try adjusting your prompt or switching to a different model.',
    useAnotherModel: 'Use another model',
    tryDifferentModel: 'Explore alternative models for better results',
  },
  token: {
    title: 'API Tokens',
    description: 'Manage your API tokens for programmatic access',
    createNew: 'Create New Token',
    loading: 'Loading tokens...',
    noTokens: 'No API Tokens',
    noTokensDescription:
      "You haven't created any API tokens yet. Create one to access the API programmatically.",
    createFirst: 'Create Your First Token',
    name: 'Name',
    created: 'Created',
    key: 'Key',
    lastUsed: 'Last used',
    actions: 'Actions',
    delete: 'Delete',
    never: 'Never',
    securityNotice: 'Security Notice',
    securityDescription:
      'API tokens have full access to your account. Keep them secure and never share them publicly.',
    createToken: 'Create API Token',
    tokenName: 'Token Name',
    tokenNamePlaceholder: 'Enter a name for your token',
    tokenNameHelp: "Choose a descriptive name to identify this token's purpose",
    yourNewToken: 'Your New API Token',
    copyWarning: "Make sure to copy this token now. You won't be able to see it again!",
    done: 'Done',
    cancel: 'Cancel',
    create: 'Create Token',
    nameRequired: 'Token name is required',
    createError: 'Failed to create token',
    deleteSuccess: 'Token deleted successfully',
    deleteError: 'Failed to delete token',
    copySuccess: 'Token copied to clipboard',
    copyDescription: 'Keep this token secure',
    fetchError: 'Failed to load tokens',
  },
  inpaint: {
    title: 'Remove Objects',
    description: 'Paint over unwanted objects to remove them from your image',
    brushSize: 'Brush Size',
    brushSizeTooltip: 'Press [ and ] to quickly adjust brush size',
    history: 'History',
    clear: 'Clear',
    reset: 'Reset',
    saveChanges: 'Save changes',
    loading: 'Processing...',
    progress: 'Progress',
    zoom: 'Zoom',
    paintInstructions: 'Paint over the objects you want to remove',
    processingTime: 'Processing time: {{time}}s',
    noImageSelected: 'No image selected',
    exportSuccess: 'Image exported successfully',
    exportError: 'Failed to export image',
  },
  projectInfo: {
    page: 'Page',
    info: 'Project Info',
    save: 'Save',
    cancel: 'Cancel',
    name: 'Name',
    description: 'Description',
    namePlaceholder: 'Enter project name',
    descriptionPlaceholder: 'Enter project description',
    noDescription: 'No description',
    public: 'Public',
    private: 'Private',
    created: 'Created',
    updated: 'Updated',
  },
  redemption: {
    title: 'Redeem Your Code',
    subtitle: 'Enter your redemption code below to add credits to your account',
    seoTitle: 'Redeem Code - Seede AI',
    seoDescription: 'Redeem your code to get credits for AI design generation',
    codeLabel: 'Redemption Code',
    codePlaceholder: 'Enter your redemption code',
    redeemButton: 'Redeem',
    currentCredits: 'Current Credits',
    creditsDescription: 'Credits are used for AI design generation',
    helpTitle: 'How to use redemption codes?',
    help1: 'Enter your redemption code in the field above',
    help2: 'Click the "Redeem" button to add credits to your account',
    help3: 'Use your credits to generate amazing AI designs',
    emptyCode: 'Please enter a redemption code',
    success: 'Redemption Successful!',
    successDescription: 'Your benefits have been added to your account.',
    error: 'Redemption Failed',
    errorDescription: 'Invalid or expired redemption code.',
    alreadyRedeemed: 'You have already redeemed this code.',
    expiredOrLimit: 'This redemption code has expired or reached its usage limit.',
    invalidCode: 'Invalid or inactive redemption code.',
    credits: 'credits',
    type: {
      credits: 'Credits',
      subscription: 'Subscription',
      feature: 'Feature',
    },
  },
  themeSelector: {
    default: 'Default',
    classicBlackWhite: 'Classic Black & White',
    oceanBlue: 'Ocean Blue',
    sunsetOrange: 'Sunset Orange',
    forestGreen: 'Forest Green',
    lavenderPurple: 'Lavender Purple',
    rosePink: 'Rose Pink',
    goldenLuxury: 'Golden Luxury',
    midnightBlue: 'Midnight Blue',
    defaultDescription: 'Default color scheme',
    classicBlackWhiteDescription: 'Classic black and white colors',
    oceanBlueDescription: 'Fresh ocean style',
    sunsetOrangeDescription: 'Warm sunset tones',
    forestGreenDescription: 'Natural forest colors',
    lavenderPurpleDescription: 'Elegant purple series',
    rosePinkDescription: 'Romantic pink tones',
    goldenLuxuryDescription: 'Premium golden colors',
    midnightBlueDescription: 'Deep night sky colors',
    addCustomTheme: 'Add Custom Theme',
    hoverToPreview: 'Hover to preview colors',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    deleteCustomTheme: 'Delete Custom Theme',
    createCustomTheme: 'Create Custom Theme',
    themeName: 'Theme Name',
    themeDescription: 'Theme Description',
    themeNamePlaceholder: 'Enter theme name',
    themeDescriptionPlaceholder: 'Enter theme description',
    colorScheme: 'Color Scheme',
    primaryColorLabel: 'Primary',
    secondaryColorLabel: 'Secondary',
    color3Label: 'Color 3',
    color4Label: 'Color 4',
    preview: 'Preview',
    themePreview: 'Theme Preview',
    cancel: 'Cancel',
    saveTheme: 'Save Theme',
    copied: 'Copied!',
  },
  credits: {
    balance: 'Credit Balance',
    remaining: 'Remaining {{count}} credits',
    remainingCredits: '残りクレジット',
    inviteFriends: 'Invite Friends',
    inviteReward: 'Get credits for each friend you invite to register',
    recharge: 'Recharge Credits',
    rechargeDesc: 'Purchase credit packages and enjoy more design features',
    rechargeNow: 'Buy Credits',
  },
  attach: {
    addAttachment: '添付ファイルを追加',
    addReferenceImage: '参考にしたいデザイン',
    uploadImageMaterial: 'デザインに必要な素材',
    uploading: 'アップロード中...',
    supportedFormats: 'PNG、JPG、JPEG、WEBP形式に対応',
    selectMaterial: '素材を選択',
    failedToLoadAssets: '素材の読み込みに失敗しました',
    material: '素材',
    remove: '削除',
    asUsage: '{{usage}}として',
    defaultUsage: '素材',
    parsing: '解析中...',
    Category: {
      recommended: 'おすすめ',
      businessMarketing: 'ビジネスマーケティング',
      creativeArt: 'クリエイティブアート',
    },
    referenceImage: '参考画像',
    materialLibrary: '素材',
    documents: 'ドキュメント',
    addDocuments: 'ドキュメントをアップロード、ワンクリックでレイアウト',
    supportedDocumentFormats: 'DOCX、PDF、TXT、MD形式に対応（最大15MB）',
    dragAndDropFiles: 'ここにファイルをドラッグ＆ドロップ',
    or: 'または',
    browseFiles: 'ファイルを参照',
    uploadSuccessful: 'アップロード成功',
    uploadFailed: 'アップロード失敗',
    fileTooBig: 'ファイルサイズが10MBの制限を超えています',
    unsupportedFormat: 'サポートされていないファイル形式',
    multipleFilesSupported: '複数ファイルに対応',
    attachmentManager: '添付ファイル管理',
    noAttachments: '添付ファイルなし',
    attachments: '添付ファイル',
  },
  material: {
    selectUsage: '用途を選択',
    singleSelect: '（単一選択）',
    background: '背景',
    product: '製品',
    model: 'モデル',
    logo: 'ロゴ',
    qrcode: 'QRコード',
    icon: 'アイコン',
    decoration: '装飾',
    texture: 'テクスチャ',
    chart: 'チャート',
    customUsagePlaceholder: 'カスタム用途',
    add: '追加',
    clickToSetUsage: 'クリックして用途を設定',
    or: 'または',
  },
  editor: {
    brand: 'ブランド',
    slogan: 'スローガン',
    title: 'タイトル',
    description: '説明',
    cta: '行動喚起',
    insertTag: 'タグを挿入',
  },
  attachTag: {
    editReferenceFeatures: 'Edit Reference Features',
    selectReferencePoints: 'Reference Points',
    multipleSelection: '(Multiple Selection)',
    referencePoints: {
      all: 'All',
      layout: 'Layout',
      style: 'Style',
      color: 'Color',
      texture: 'Texture',
      copy: 'Copy',
      font: 'Font',
    },
  },
  materialList: {
    selectUsage: 'Usage',
    selectedMaterials: 'Selected Materials',
    noSelectedMaterials: 'No materials selected',
    recentlyUploadedMaterials: 'Recently Uploaded Materials',
    failedToLoadAssets: 'Failed to load assets',
    noMaterials: 'No materials available',
    uploadMaterialsToUse: 'Upload materials to use them in your designs',
  },
  workspaceAsset: {
    all: 'すべて',
    favorites: 'お気に入り',
    recent: '最近アップロード',
    ai: 'AI 生成',
    searchAssets: 'アセットを検索...',
    upload: 'アップロード',
    select: '選択',
    cancel: 'キャンセル',
    selectedCount: '{{count}} 件を選択',
    selectAll: 'すべて選択',
    clearSelection: '選択をクリア',
    delete: '削除',
    confirmBatchDelete: '{{count}} 件のアセットを削除しますか？この操作は元に戻せません。',
    loadingAssets: 'アセットを読み込み中...',
    emptyTitle: 'アセットライブラリは空です',
    emptyDescription: '最初のアセットをアップロードしてクリエイティブライブラリを構築しましょう',
    uploadAsset: 'アセットをアップロード',
    loadingMore: 'さらに読み込み中...',
    noSearchResults: '検索条件に一致するアセットはありません',
    noSearchResultsDescription:
      '「{{query}}」に一致するアセットは見つかりませんでした。別のキーワードをお試しください。',
    somethingWentWrong: '問題が発生しました',
    tryAgain: '再試行',
    uploadFailed: 'アップロードに失敗しました',
  },
  fillPanel: {
    solid: 'Solid',
    gradient: 'Gradient',
    gradientDirection: 'Gradient Direction',
  },
  strokePanel: {
    stroke: 'Stroke',
    simple: 'Simple',
    advanced: 'Advanced',
    strokeLayers: 'Stroke Layers',
    addLayer: 'Add Layer',
    layer: 'Layer',
    color: 'Color',
    width: 'Width',
    opacity: 'Opacity',
    blur: 'Blur',
    offsetX: 'Offset X',
    offsetY: 'Offset Y',
    lineCap: 'Line Cap',
    lineJoin: 'Line Join',
    miterLimit: 'Miter Limit',
    round: 'Round',
    butt: 'Butt',
    square: 'Square',
    miter: 'Miter',
    bevel: 'Bevel',
  },
  quickQrCode: {
    editQrCode: 'Edit QR Code',
    qrCodeEditor: 'QR Code Editor',
    typeSelection: 'Type Selection',
    content: 'Content',
    generating: 'Generating...',
    generateQrCode: 'Generate QR Code',
    types: {
      text: 'Text',
      url: 'Link',
      email: 'Email',
      phone: 'Phone',
      wifi: 'WiFi',
      contact: 'Contact',
    },
    placeholders: {
      text: 'Enter any text',
      url: 'https://example.com',
      email: 'user@example.com',
      phone: '+1 555 123 4567',
      wifi: 'WiFi Name;Password;Encryption Type',
      contact: 'Name;Phone;Email',
    },
    generateFailed: 'Failed to generate QR code',
  },
  chatContent: {
    referenceImages: 'Reference Images',
    colorScheme: 'Color Scheme',
    materialFiles: 'Material Files',
    libraryItems: 'Library Items',
    designLibrary: 'Design Library',
    material: 'Material',
  },
  modelSelector: {
    selectModel: 'Select Model',
    recommendedModels: 'Recommended Models',
    allModels: 'All Models',
    exploreMore: 'Explore More Models',
    additionalModels: 'More models available',
    otherModels: 'Other Models',
    showLess: 'Show Less',
    mostPopular: 'Most Popular',
    multimodal: 'Supports Image Input',
    limitedTimeFree: '期間限定無料',
    new: '新着',
    promoDefault: 'Gemini 3 Pro 全新上線',
    promoGemini: 'そう、これです。ぜひお試しください',
  },
  browserCompatibility: {
    error: {
      title: 'Browser Compatibility Error',
      description: "Your browser doesn't support required features.",
      checkDetails: 'Check compatibility details',
    },
    checkDetails: 'Check browser compatibility details',
  },
  textEffect: {
    title: 'Text Effects',
    description: 'Select preset styles',
    clearEffects: 'Clear Effects',
  },
  nodeTypes: {
    text: 'Text',
    image: 'Image',
    shape: 'Shape',
    path: 'Path',
    col: 'Column',
    row: 'Row',
    group: 'Group',
    frame: 'Frame',
    video: 'Video',
  },
  browser: {
    title: 'Browser Compatibility',
    description: "Check your browser's compatibility with Seede AI features",
    overallStatus: 'Overall Status',
    browserInfo: 'Browser Info',
    featureDetails: 'Feature Details',
    status: 'Status',
    retest: 'Retest',
    testing: 'Testing...',
    analyzing: 'Analyzing compatibility...',
    checkComplete: 'Compatibility Check Complete',
    checkCompleteDesc: 'Browser compatibility analysis finished successfully.',
    checkFailed: 'Check Failed',
    checkFailedDesc: 'Failed to run compatibility check.',
    recommendChrome: 'Recommended Browser: Chrome',
    recommendChromeDesc:
      'For the best Seede AI experience, we strongly recommend using the latest version of Google Chrome browser.',
    downloadChrome: 'Download Chrome',
    statuses: {
      fullyCompatible: 'Fully Compatible',
      compatibleWithWarnings: 'Compatible with Warnings',
      incompatible: 'Incompatible',
      unknown: 'Unknown',
      supported: 'Supported',
      notSupported: 'Not Supported',
    },
    categories: {
      required: 'Required',
      optional: 'Optional',
      compatible: 'Compatible',
      browser: 'Browser',
      version: 'Version',
      engine: 'Engine',
    },
    results: {
      pass: 'PASS',
      fail: 'FAIL',
      warn: 'WARN',
      yes: 'YES',
      no: 'NO',
    },
    issues: {
      criticalTitle: 'Critical Issues',
      criticalDesc: 'Update your browser for Seede AI compatibility.',
      performanceTitle: 'Performance Warnings',
      performanceDesc: 'Some features may have reduced performance.',
      excellentTitle: 'Excellent',
      excellentDesc: 'Full compatibility with all Seede AI features.',
    },
  },
  about: {
    title: '私たちについて',
    subtitle:
      '誰もが心の中に創造性の種を持っており、それは育まれ、芽を出し、花を咲かせるに値します',
    vision: {
      title: 'ビジョン',
      content: [
        '私たちは、AIが創造の境界を再定義すると信じています。未来では、誰もが簡単な会話を通じてアイデアを美しいビジュアル作品に変えることができます。',
        'Seede AIは、想像力と現実の橋渡しとなり、デザインを少数の人々のためのスキルではなく、誰もがアクセスできるものにすることを約束します。',
      ],
    },
    mission: {
      title: 'ミッション',
      content: [
        'デザインの障壁を下げ、誰もが簡単にプロフェッショナルレベルのビジュアルコンテンツを作成できるようにする。',
        'AIモデルとユーザー体験を継続的に最適化し、よりスマートで、効率的で、創造的なデザインソリューションを提供する。',
        'インスピレーションが衝突し、成長するオープンでフレンドリーな創造的コミュニティを構築する。',
      ],
    },
    values: {
      title: '価値観',
      content: [
        'イノベーション第一：私たちはテクノロジーの力を信じ、常にイノベーションとブレークスルーを追求します。',
        'ユーザー中心：ユーザーのニーズに耳を傾け、すべての創造的体験に責任を持つ。',
        'シンプル＆効率的：複雑なテクノロジー、シンプルな体験—創造をその本質に戻す。',
        'オープン＆シェア：私たちはすべてのクリエイターを歓迎し、デザインの無限の可能性を一緒に探求します。',
      ],
    },
    story: {
      title: 'ストーリー',
      content: [
        '私はSeede AIの創設者、Evanです。多くの人が、なぜAIデザインツールを作ることにしたのかと尋ねます。私の物語は、多くの人が期待するものとは異なるかもしれません。',
        '私は子供の頃から「創造する」ことに夢中でした。高校時代、私は「Deyang Forum」という地元のフォーラムを一人で構築し維持しました。当時は技術についてあまり知識がなく、基本的なPHPしか知りませんでしたが、ユーザーが実際に私の製品を使用しているのを見たとき、そして一部の人がそれを「公式運営」だと誤解したとき、その達成感により、初めて技術の背後にある「人」の温かさを感じました。',
        '大学ではサイバーセキュリティを選び、いくつかの賞を受賞しましたが、次第に、私が本当に愛していたのは「ハッキングと防御」ではなく、「ゼロから何かを作り出すこと」だと気づきました。そこで2年生の時、キャンパスを離れ、本当の業界に入って学び成長することを選びました。',
        '美団（Meituan）での期間中、ServerlessコンセプトとVercelに深く触発され、私はゼロから独立してVercelシステムのミニ版を設計し実装しました。それは純粋な技術アーキテクチャから製品思考でソリューションを構築することに真に移行した初めての経験でした。この経験により深く気づきました：技術自体は終点ではなく、ユーザーにスムーズで効率的な体験を創造することが核心です。',
        '美団を離れた後、私はスタートアップのDora AIに参加し、正式にデザインツール分野に入りました。私はFigmaとCanvaを深く研究するために多くの時間を投資しました。単なるユーザーとしてではなく、製品構築者の視点から、現代のデザインツールの背後にあるアーキテクチャロジック、インタラクションコンセプト、実装パスを理解しました。それがデザインツールは本質的に人々がアイデアをより自由に表現することを助けることであり、技術はこの目標に奉仕すべきだという初めての体系的な理解でした。ChatGPTのリリース後、私はさらに確信しました：AIは必然的にデザインの未来を再構築します。',
        'こうして、Seede AIが誕生しました。「Seede」という名前は、「Seed」と「Design」を組み合わせたものです。私たちは、誰もが心の中に創造性の種を持っており、それは育まれ、芽を出し、花を咲かせるに値すると信じています—複雑な技術やツールに妨げられるべきではありません。',
        '今日、Seede AIはこのような製品を構築することに専念しています：デザインの背景は必要ありません。アイデアを入力するだけで、AIが美しく実用的な画像、ポスター、招待状、インフォグラフィック…を生成するのを手伝います。特にテキストと情報デザインにおいて、レイアウトコントロールと視覚効果を継続的に最適化し、すべてのユーザーが簡単かつ自信を持って自分自身を表現できることを願っています。',
        '私にとって、技術は決してコードとモデルだけではありません；それは人間性への架け橋です。私たちはまだ初期段階で改善すべき点が多くありますが、私は固く信じています：真の技術は、人々をより自由に、より自信に満ち、より創造的にするべきです。',
        'あなたと一緒により知的でオープンなデザインの世界を構築することを楽しみにしています。—— Evan, Seede AI 創設者',
      ],
    },
  },
  order: {
    title: '注文',
    loadingOrders: '注文を読み込み中...',
    noOrdersFound: '注文が見つかりません',
    failedToLoadOrders: '注文の読み込みに失敗しました',
    noMoreOrders: 'これ以上の注文はありません',
    id: '注文ID',
    date: '日付',
    details: '詳細',
    amount: '金額',
    status: 'ステータス',
    actions: '操作',
    paymentMethod: {
      alipay: 'アリペイ',
      wxpay: 'WeChat Pay',
      gift: 'ギフト',
      creditCard: 'クレジットカード',
      payment: '支払い',
    },
    statusLabels: {
      succeeded: '成功',
      paid: '支払済み',
      complete: '完了',
      pending: '保留中',
      processing: '処理中',
      failed: '失敗',
      cancelled: 'キャンセル済み',
    },
    invoice: {
      title: '請求書',
      apply: '請求書を申請',
      cancel: '申請をキャンセル',
      download: '請求書をダウンロード',
      applyTitle: '請求書を申請',
      applyDescription: '請求書情報を入力してください。1-3営業日以内に電子請求書を発行いたします。',
      orderNumber: '注文番号',
      invoiceTitle: '請求書タイトル',
      titlePlaceholder: '会社名または個人名を入力',
      taxNumber: '税務番号',
      taxNumberPlaceholder: '法人税務番号（法人請求書の場合必須）',
      email: 'メールアドレス',
      emailPlaceholder: '電子請求書の受信用',
      remark: '備考',
      remarkPlaceholder: '特別な要件があればご記入ください',
      submit: '申請を送信',
      status: {
        pending: '処理中',
        issued: '発行済み',
        cancelled: 'キャンセル済み',
      },
      error: {
        titleRequired: '請求書タイトルは必須です',
      },
      applySuccess: '請求書申請が正常に送信されました',
      applyFailed: '請求書申請の送信に失敗しました',
      cancelSuccess: '請求書申請が正常にキャンセルされました',
      cancelFailed: '請求書申請のキャンセルに失敗しました',
    },
  },
};
